var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid p-5 max-width mx-auto" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-md-3 d-flex align-items-center" }, [
        _c(
          "a",
          {
            attrs: {
              href: "/problem/collection/",
              "data-nav-problems-collection": ""
            }
          },
          [_vm._v(_vm._s(_vm.T.problemCollectionBackCollections))]
        )
      ]),
      _c("div", { staticClass: "col mb-4" }, [
        _c("h1", { staticClass: "title-font p-0" }, [_vm._v(_vm._s(_vm.title))])
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col col-md-3" },
        [
          _c("omegaup-problem-filter-tags", {
            attrs: {
              "selected-tags": _vm.selectedTags,
              tags: _vm.availableTags,
              "public-quality-tags": _vm.publicQualityTags
            },
            on: {
              "new-selected-tag": function(selectedTags) {
                return _vm.$emit(
                  "apply-filter",
                  _vm.columnName,
                  _vm.sortOrder,
                  _vm.difficulty,
                  _vm.quality,
                  selectedTags
                )
              }
            }
          }),
          _c("omegaup-problem-filter-difficulty", {
            attrs: { "selected-difficulty": _vm.difficulty },
            on: {
              "change-difficulty": function(difficulty) {
                return _vm.$emit(
                  "apply-filter",
                  _vm.columnName,
                  _vm.sortOrder,
                  difficulty,
                  _vm.quality,
                  _vm.selectedTags
                )
              }
            }
          }),
          _c("omegaup-problem-filter-quality", {
            attrs: { quality: _vm.quality },
            on: {
              "change-quality": function(quality) {
                return _vm.$emit(
                  "apply-filter",
                  _vm.columnName,
                  _vm.sortOrder,
                  _vm.difficulty,
                  quality,
                  _vm.selectedTags
                )
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col p-0" },
        [
          !_vm.problems || _vm.problems.length == 0
            ? _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "empty-table-message" }, [
                  _vm._v(
                    " " + _vm._s(_vm.T.courseAssignmentProblemsEmpty) + " "
                  )
                ])
              ])
            : _c("omegaup-problem-base-list", {
                attrs: {
                  problems: _vm.problems,
                  "logged-in": _vm.loggedIn,
                  "selected-tags": _vm.selectedTags,
                  "pager-items": _vm.pagerItems,
                  "wizard-tags": _vm.wizardTags,
                  language: _vm.language,
                  languges: _vm.languages,
                  keyword: _vm.keyword,
                  modes: _vm.modes,
                  columns: _vm.columns,
                  mode: _vm.modes,
                  column: _vm.column,
                  tags: _vm.tagsList,
                  "sort-order": _vm.sortOrder,
                  "column-name": _vm.columnName,
                  path: "/problem/collection/" + _vm.level + "/"
                },
                on: {
                  "apply-filter": function(columnName, sortOrder) {
                    return _vm.$emit(
                      "apply-filter",
                      columnName,
                      sortOrder,
                      _vm.difficulty,
                      _vm.quality,
                      _vm.selectedTags
                    )
                  }
                }
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }